import React, { useEffect, useState } from "react";
import loc1 from '../Assets/loc-1.jpg'
import loc2 from '../Assets/loc-2.jpg'
import loc3 from '../Assets/loc-3.jpg'
import loc4 from '../Assets/loc-4.jpg'
import { Get_Api } from "../ApiUrls";

const places = [
    { name: "WAKAD", properties: 23, image: loc1 },
    { name: "HINJEWADI", properties: 21, image: loc2 },
    { name: "GAHUNJE", properties: 14, image: loc3 },
    { name: "BANER", properties: 15, image: loc4 },
];


const PopularePlaces = () => {

    const [All_Locations, setAll_Locations] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);
    const Get_All_Locations = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api('api/admin/GetAllLocation');
            setAll_Locations(response.data);
            setIsUploading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        Get_All_Locations();
    }, []);


    return (
        <div className="popular-places">
            <h2>POPULAR PLACES</h2>
            <div className="grid-container">
                {All_Locations?.slice(0, 4)?.map((place, index) => (
                    <div
                        key={index}
                        className={`place-card`}
                        style={{ backgroundImage: `url(${place?.Image})` }}
                    >
                        <span className="properties-badge">{place?.properties || "20"} properties</span>
                        <h3 className="place-name">{place?.Location}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PopularePlaces;
